import React, { useEffect, useState } from 'react';
import { makeStyles, Tooltip, fade, InputAdornment, Badge } from '@material-ui/core';
import { Cancel, LocalOffer } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import ChipInput from 'material-ui-chip-input';

const useStyles = makeStyles((theme) => ({
  chipInputChip: {
    height: '24px',
    maxWidth: 'fill-available'
  },
  chipInputRoot: {
    maxWidth: '100%'
  },
  chipInputChipContainerBlock: {
    display: 'block'
  },
  chipInputInputNone: {
    display: 'none'
  },
  chipInputInputBlock: {
    display: 'block',
    border: '2px solid #C4CDCE',
    borderRadius: '4px',
    height: '100%',
    padding: 0,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:focus': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    transition: theme.transitions.create('width'),
    width: '100%'
  },
  containerTags: {
    marginBottom: '10px'
  },
  iconTag: {
    margin: '0 2px',
    cursor: 'pointer',
    color: theme.palette.primary.main
  },
  chipInputInputRoot: {
    height: '24px'
  }
}));

const Tags = (props) => {
  const { item, update } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const [editTags, setEditTags] = useState(false);

  const handleUpdateTags = async (tags) => {
    try {
      delete item.users;
      delete item.location;
      setEditTags(false);
      if (tags) {
        await update({ ...item, tags });
      } else {
        await update({ ...item, tags: [] });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onClickTags = async () => {
    setEditTags(!editTags);
  };

  useEffect(() => {
    document.getElementById(`tag-input-${item.id}`).focus();
  }, [editTags]);

  return (
    <ChipInput
      InputProps={{
        endAdornment: editTags ? (
          <InputAdornment position='end' onClick={onClickTags} className={classes.iconTag}>
            <Cancel />
          </InputAdornment>
        ) : null,
        startAdornment: !editTags ? (
          <Tooltip title={t('tags:add')}>
            <InputAdornment position='end' onClick={onClickTags} className={classes.iconTag}>
              <Badge badgeContent={'+'}>
                <LocalOffer color='primary' />
              </Badge>
            </InputAdornment>
          </Tooltip>
        ) : null,
        id: `tag-input-${item.id}`
      }}
      defaultValue={item.tags}
      onChange={(tags) => handleUpdateTags(tags)}
      disableUnderline
      classes={{
        root: classes.chipInputRoot,
        inputRoot: !editTags ? classes.chipInputInputRoot : null,
        input: editTags ? classes.chipInputInputBlock : classes.chipInputInputNone,
        chipContainer: editTags ? classes.chipInputChipContainerBlock : null,
        chip: classes.chipInputChip
      }}
    />
  );
};

export default Tags;
